import { render, staticRenderFns } from "./ChartOfAccountsCreateUpdate.vue?vue&type=template&id=58cb575d&"
import script from "./ChartOfAccountsCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ChartOfAccountsCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports